import BreadcrumbTitle from "components/BreadcrumbTitle"
import { SaveButton } from "components/Buttons"
import PageMetaTags from "components/PageMetaTags"
import Table from "components/Table"
import React, { useEffect, useState } from "react"
import { connect } from "react-redux"
import { Link, withRouter } from "react-router-dom"
import { Col, Container, Input, Row } from "reactstrap"
import {
  deleteClient,
  getClientsTableData,
  hideDeleteClientModal,
  openDeleteClientModal,
} from "store/actions"
import clientsListColumns from "./clientsListColumns"
import { URL_PATHS } from "constants/index"
import ModalComponent from "components/Modals"

const Clients = ({
  clientsTableData,
  getClientsTableData,
  loading,
  deleteClientModalIsOpen,
  deleteClient,
  openDeleteClientModal,
  hideDeleteClientModal,
  history,
}) => {
  const [searchValue, setSearchValue] = useState("")
  const [showResetButton, setShowResetButton] = useState(false)
  const [selectedClient, setSelectedClient] = useState({})

  useEffect(() => {
    getClientsTableData({ page: 1, per_page: 15 })
  }, [])

  const onDeleteClient = item => {
    setSelectedClient(item)
    openDeleteClientModal()
  }

  const actions = [
    {
      name: "Edit",
      onClick: item => {
        history.push(`/vendors/${item.id}`)
      },
      icon: "bx bx-edit",
      isAvailable: true,
    },
    {
      name: "Features",
      onClick: item => {
        history.push(`/vendors/${item.id}/features`)
      },
      icon: "bx bx-cog",
      isAvailable: true,
    },
    {
      name: "Delete",
      onClick: onDeleteClient,
      icon: "bx bx-trash",
      isAvailable: true,
    },
  ]

  const handlePageChange = page => {
    getClientsTableData({
      ...{ page: page, per_page: 15 },
      ...(searchValue.trim().length ? { search: searchValue } : {}),
    })
  }

  const handleDeleteClient = () => {
    deleteClient({
      id: selectedClient.id,
      callback: () => getClientsTableData({ page: 1, per_page: 15 }),
    })
  }

  const handleSearch = () => {
    if (searchValue.trim().length) {
      getClientsTableData({ page: 1, per_page: 15, search: searchValue })
      setShowResetButton(true)
    }
  }

  const handleResetSearch = () => {
    getClientsTableData({ page: 1, per_page: 15 })
    setSearchValue("")
    setShowResetButton(false)
  }

  return (
    <React.Fragment>
      <div className="page-content">
        <PageMetaTags title="Client List" />
        <Container fluid>
          <Row>
            <Col>
              <BreadcrumbTitle
                title="Client List"
                breadcrumbItems={[
                  { title: "Dashboard" },
                  { title: "Client List" },
                ]}
              />
            </Col>
          </Row>
          <Row className="d-flex justify-content-end">
            <Col xs="auto" className={"mb-3"}>
              <Link to={URL_PATHS.ADD_CLIENT}>
                <SaveButton
                  type="button"
                  fullWidth={true}
                  content={"Add Client"}
                  onClick={() => {}}
                />
              </Link>
            </Col>
          </Row>
          <Row>
            <Col sm={6} md={5} xl={4} className="my-1">
              <Input
                value={searchValue}
                onChange={event => {
                  setSearchValue(event.target.value)
                }}
                placeholder="Search"
              />
            </Col>
            <Col xs={6} sm={2} xl={1} className="my-1">
              <SaveButton
                type="button"
                fullWidth={true}
                content="Search"
                onClick={handleSearch}
              />
            </Col>
            {showResetButton && (
              <Col xs={6} sm={2} xl={1} className="my-1">
                <SaveButton
                  fullWidth={true}
                  type="button"
                  content="Reset"
                  color="light"
                  onClick={handleResetSearch}
                />
              </Col>
            )}
          </Row>
          <Row className="my-3">
            <Col>
              <Table
                columns={clientsListColumns()}
                data={clientsTableData?.data}
                actions={actions}
                loadingData={loading}
                paginationData={{
                  current_page: clientsTableData?.current_page,
                  last_page: clientsTableData?.last_page,
                  total_items: clientsTableData?.total,
                  items_per_page: clientsTableData?.per_page,
                  from: clientsTableData?.from,
                  to: clientsTableData?.to,
                  first_page: 1,
                }}
                onPageChange={handlePageChange}
              />
            </Col>
          </Row>
        </Container>
      </div>
      <ModalComponent
        open={deleteClientModalIsOpen}
        onClose={hideDeleteClientModal}
        title={`Delete client - ${selectedClient?.name}`}
      >
        <Row>
          <h5>Are you sure you want to delete this Client and its Contents?</h5>
        </Row>
        <Row className="mt-3">
          <Col>
            <SaveButton
              type="button"
              fullWidth={true}
              color="danger"
              content="Cancel"
              onClick={hideDeleteClientModal}
            />
          </Col>
          <Col>
            <SaveButton
              type="button"
              content="Delete"
              fullWidth={true}
              onClick={handleDeleteClient}
            />
          </Col>
        </Row>
      </ModalComponent>
    </React.Fragment>
  )
}

const mapStateToProps = state => ({
  clientsTableData: state.clients.clientsTableData,
  loading: state.clients.loading,
  deleteClientModalIsOpen: state.clients.deleteClientModalIsOpen,
})

const mapDispatchToProps = dispatch => ({
  getClientsTableData: values => dispatch(getClientsTableData(values)),
  deleteClient: values => dispatch(deleteClient(values)),
  openDeleteClientModal: () => dispatch(openDeleteClientModal()),
  hideDeleteClientModal: () => dispatch(hideDeleteClientModal()),
})

export default connect(mapStateToProps, mapDispatchToProps)(withRouter(Clients))
